import React from 'react';
import { createPortal } from 'react-dom';
import './style.scss';

export const Modal = ({ children }) => createPortal(<div className="overlay">{children}</div>, document.querySelector('#portal'));
